var $ = require('jQuery');
var Component = require('../../Component');
var Scrollbar = require('../../Scrollbar');
var template = require('../../../template/multiple-forward-window.html');
var utils = require('../../../global/utils');
var dispatcher = require('.././../../global/dispatcher');
var ActionType = require('./../../../constant/ActionType');
var config = require('../../../global/config');
var isEmpty = utils.isEmpty;
var isAnonymousSession = utils.isAnonymousSession;

var compare = function (a, b) {
    if (a.sort_time > b.sort_time)
      return -1;
    else if (a.sort_time < b.sort_time)
      return 1;
    else
      return 0;
};

var sortSessions = function (sessions) {
    var topSessions = [];
    var sesTopSessions = [];
    var normalSessions = [];
    sessions.forEach(function (session, index) {
      if (session.is_top_group) {
        topSessions.push(session);
      } else if (session.contact && session.contact.msg_set && session.contact.msg_set.ses_top == 1 && isEmpty(session.contact.shop_id)) {
        sesTopSessions.push(session);
      } else {
        normalSessions.push(session);
      }
    });
    topSessions.sort(compare);
    sesTopSessions.sort(compare);
    normalSessions.sort(compare);
    return topSessions.concat(sesTopSessions).concat(normalSessions);
};

var MultipleForwardWindow = function (options) {
    (function (self) {
        var defaults = {
            selected: {},
            selectedNum: 0,
            sessionDomNumber: 0,
            template: template,
            sessionTpl: '<div class="session-to-forward"><div class="session-forward-left ${{im-show-shop-icon}}"><div class="session-forward-portrait">'+
            '<img alt="" class="session-to-forward-avatar" crossorigin="anonymous" src="${{avatar}}">'
            +'</div><span class="session-forward-username">${{username}}</span><span class="im-shop-icon">商家聊天</span></div><div class="session-forward-right"><div class="session-forward-checkbox" data-index="${{index}}"></div></div></div>',
            selectedSessionTpl: '<div class="session-to-forward"><div class="session-forward-left ${{im-show-shop-icon}}"><div class="session-forward-portrait">'+
            '<img alt="" class="session-to-forward-avatar" crossorigin="anonymous" src="${{avatar}}">'
            +'</div><span class="session-forward-username">${{username}}</span><span class="im-shop-icon">商家聊天</span></div><div class="session-forward-right"><div class="session-forward-uncheckbox" data-index="${{index}}"></div></div></div>'
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
        self._element.click(function(e){
            var _target = $(e.target);
            // if(_target.hasClass('multiple-forward-window-bg') || _target.hasClass('multiple-forward-window')){
                e.stopPropagation();
            // }
            if(_target.hasClass('multiple-forward-window-close')) {
                dispatcher.dispatch({
                    type: ActionType.MULTIPLE_FORWARD_WINDOW_CLOSE
                });
            }
            if(_target.hasClass('multiple-forward-window-submit')) {
                if(self._options.selectedNum == 0 ){
                    return 
                }
                var session;
                var toUsers = [];
                for(var index in self._options.selected) {
                    session = self._options.selected[index];
                    if (session && session.user && session.user.user_id && !isEmpty(session.user.user_source)) {
                        toUsers.push(session);
                    }
                }
                dispatcher.dispatch({
                    type: ActionType.MULTIPLE_FORWARD_WINDOW_SUBMIT,
                    data: {
                        toUsers: toUsers,
                        messages: self._data.messages,
                        forward_one_by_one: self._data.forward_one_by_one,
                        leaveMsg: self.getMessage().msg
                    }
                });
            }
            if(_target.hasClass('session-forward-checkbox')) {
                var _index = _target.data('index');
                if (!isNaN(_index)) {
                    if ((self._options.single_select && self._options.selectedNum > 0)) {
                        for(var key in self._options.selected) {
                            if (key !== _index + '') {
                                self.unselectSession(key);
                            }
                        }
                    }
                    if (!self._options.selected[_index]) {
                        self.selectSession(_index);
                    }
                }
            }
            if(_target.hasClass('session-forward-uncheckbox')) {
                var _index = _target.data('index');
                if (!isNaN(_index)) {
                    self.unselectSession(_index);
                }
            }
          });
    })(this);
};
MultipleForwardWindow.prototype = Object.create(Component.prototype);
MultipleForwardWindow.prototype.render = function () {
    var self = this;
    var $element = this.getElement();
    var sessions = this._data.sessions || [];
    var contacts = this._data.contacts || {};
    $element.find(".multiple-sessions-container").html('');
    if (isEmpty(self._children['sessionlist-scrollbar'])) {
        this.addScrollbar();
    } else {
        self._children['sessionlist-scrollbar'] && self._children['sessionlist-scrollbar'].scroll(0);
    }
    self.addMoreSessions(sessions, contacts);
};
MultipleForwardWindow.prototype.bindEvents = function () {
    $element.find(".session-to-forward-avatar").error(function () {
        var current_src= $(this).attr('src');
        if(current_src !== config['default-avatar']){
            $(this).attr('src', config['default-avatar']);
        }
    });
};
MultipleForwardWindow.prototype.selectSession = function (index) { 
    var self = this;
    var $element = this.getElement();
    var sessions = this._data.sessions || [];
    var contacts = this._data.contacts || {};
    var element;
    var is_shop_session;
    if (!self._options.selected[index]) {
        if(!isEmpty(contacts) && !isEmpty(sessions[index]) && !isEmpty(sessions[index].user)){
            self._options.selected[index] = sessions[index];
            id_source = sessions[index].user.user_id + "@" + sessions[index].user.user_source;
            is_shop_session = sessions[index].user.shop_id && sessions[index].user.shop_source;
            if (is_shop_session) {
                id_source += '@@' + sessions[index].user.shop_id + '@' + sessions[index].user.shop_source;
            }
            if (!isEmpty(contacts[id_source])) {
                let default_name = ''
                if (isAnonymousSession(contacts[id_source])) {
                    default_name = '游客' + contacts[id_source].user_id;
                }
                element = $(self._options.selectedSessionTpl.replace('${{index}}', index).replace('${{avatar}}', contacts[id_source].avatar).replace('${{username}}', (contacts[id_source].remark && contacts[id_source].remark.remark_name ? contacts[id_source].remark.remark_name : contacts[id_source].user_name) || default_name || '未知').replace('${{im-show-shop-icon}}', is_shop_session ? 'im-show-shop-icon' : ''));
                // 加载失败之后，恢复默认图像
                element.find(".session-to-forward-avatar").error(function () {
                    var current_src= $(this).attr('src');
                    if(current_src !== config['default-avatar']){
                        $(this).attr('src', config['default-avatar']);
                    }
                });
                $element.find('.multiple-selected-sessions').append(element);
                $element.find('.multiple-sessions-container .session-to-forward .session-forward-checkbox[data-index="' + index + '"]').parents('.session-to-forward').addClass('session-to-forward-selected');
                self._options.selectedNum += 1;
                if (self._options.selectedNum > 0) {
                    $element.find('.multiple-selected-sub-title').show().html('已选择' + self._options.selectedNum + '个聊天')
                    $element.find('.multiple-forward-window-submit').css('background','#3478F6')
                    $element.find('.multiple-forward-window-submit').css('border','1px solid #3478F6')
                }
            }
        }
    }
}
MultipleForwardWindow.prototype.unselectSession = function (index) { 
    var self = this;
    var $element = this.getElement();
    if (self._options.selected[index]) {
        delete self._options.selected[index];
        $element.find('.multiple-selected-sessions .session-to-forward .session-forward-uncheckbox[data-index="' + index + '"]').parents('.session-to-forward').remove();
        $element.find('.multiple-sessions-container .session-to-forward .session-forward-checkbox[data-index="' + index + '"]').parents('.session-to-forward').removeClass('session-to-forward-selected');
        self._options.selectedNum -= 1;
        if (self._options.selectedNum > 0) {
            $element.find('.multiple-selected-sub-title').html('已选择' + self._options.selectedNum + '个聊天')
        } else {
            $element.find('.multiple-selected-sub-title').hide();
            $element.find('.multiple-forward-window-submit').css('background','grey')
            $element.find('.multiple-forward-window-submit').css('border','1px solid grey')

        }
    }
}
MultipleForwardWindow.prototype.reset = function () {
    //var content = this._element.find(".multiple-sessions-body");
    //content.html('<div class="multiple-sessions-window"><div class="multiple-sessions-container"></div></div>');
    var self = this;
    self._options.selected = {};
    self._options.selectedNum = 0;
    self._options.sessionDomNumber = 0;
    self._options.isLoading = false;
    self._options.hasMore = true;
    self._data.sessions = [];
    self._data.messages = [];
    var $element = this.getElement();
    $element.find('.multiple-selected-sessions').html('');
    $element.find('.multiple-sessions-container').html('');
    $element.find('.multiple-selected-sub-title').hide();
    $element.find('.multiple-input textarea').val('');
    self._children['sessionlist-scrollbar'] && self._children['sessionlist-scrollbar'].scroll(0);
};
MultipleForwardWindow.prototype.addScrollbar = function () {
    var self = this;
    var scrollbar = new Scrollbar({
        window: self._element.find(".multiple-sessions-window"),
        content: self._element.find(".multiple-sessions-container")
    });
    self._element.find(".multiple-sessions-window").append(scrollbar.getElement());
    self._children['sessionlist-scrollbar'] = scrollbar;
    setTimeout(function () {
        scrollbar.init();
    }, 0);
    scrollbar.addEventListener("scrolled", function (scrolltop) {
        var wrapHeight = self.getElement().find(".multiple-sessions-window").height();
        var listHeight = self.getElement().find(".multiple-sessions-container").height();
        if (listHeight < wrapHeight) {
          return false
        }
        if (listHeight - wrapHeight - scrolltop <= 5 && self._options.hasMore && !self._options.isLoading) {
            self._options.isLoading = true;
            self.getMoreSessions(function(sessions, contacts, hasMore){
                if (sessions && sessions.length) {
                    self.addMoreSessions(sessions, contacts);
                }
                self._options.isLoading = false;
                self._options.hasMore = hasMore;
            });
        }
    });
};
MultipleForwardWindow.prototype.addMoreSessions = function (sessions, contacts) {
    var self = this;
    var $element = this.getElement();
    var html = [];
    var element;
    var id_source;
    var index_base = self._options.sessionDomNumber;
    var _index_base = self._options.sessionDomNumber;
    var is_shop_session;
    if(!isEmpty(contacts)){
        sessions.forEach(function(session, index){
            if (session && !isEmpty(session.user)) {
                id_source = session.user.user_id + "@" + session.user.user_source;
                if (sessions[index].user.shop_id && sessions[index].user.shop_source) {
                    id_source += '@@' + sessions[index].user.shop_id + '@' + sessions[index].user.shop_source;
                }
                if (!isEmpty(contacts[id_source])) {
                    session.contact = contacts[id_source];
                }
            }
        });
        sessions = sortSessions(sessions);
        if (index_base === 0) {
            self._data.sessions = sessions;
        } else {
            self._data.sessions = self._data.sessions.concat(sessions);
            self._data.contacts = Object.assign(self._data.contacts, contacts);
        }
        sessions.forEach(function(session, index){
            var contact = session.contact;
            if (contact) {
                _index_base = index_base + (index_base > 0 ? (1+index) : index);
                is_shop_session = sessions[index].user.shop_id && sessions[index].user.shop_source;
                let default_name = ''
                if (isAnonymousSession(contact)) {
                    default_name = '游客' + contact.user_id;
                }
                element = $(self._options.sessionTpl.replace('${{index}}', _index_base).replace('${{avatar}}', contact.avatar).replace('${{username}}', (contact.remark && contact.remark.remark_name ? contact.remark.remark_name : (contact.user_name)) || default_name || '未知').replace('${{im-show-shop-icon}}', is_shop_session ? 'im-show-shop-icon' : ''));
                // 加载失败之后，恢复默认图像
                element.find(".session-to-forward-avatar").error(function () {
                    var current_src= $(this).attr('src');
                    if(current_src !== config['default-avatar']){
                        $(this).attr('src', config['default-avatar']);
                    }
                });
                html.push(element);
            }
        })
        if ($element.find(".multiple-sessions-container .session-to-forward").length) {
            $element.find(".multiple-sessions-container").append(html);
        } else {
            $element.find(".multiple-sessions-container").html(html);
        }
        self._options.sessionDomNumber = _index_base;
        self._children['sessionlist-scrollbar'] && self._children['sessionlist-scrollbar'].calHeight();
    }
};
MultipleForwardWindow.prototype.getMoreSessions = function (callback) {
    if (this._data.sessions.length && typeof callback === 'function' && typeof this._options.getMoreSessions === 'function') {
        var last_session = this._data.sessions[this._data.sessions.length-1];
        var params = {
            last_other_id: last_session.user.user_id,
            last_other_source: last_session.user.user_source,
            last_msg_id: last_session.msg.msg_id,
            count: 50
        }
        this._options.getMoreSessions(params, callback);
    }
};
MultipleForwardWindow.prototype.getMessage = function () {
    var $element = this.getElement();
    return {
        type: 'text',
        msg: $element.find('.multiple-input textarea').val()
    };
};
MultipleForwardWindow.prototype.show = function () {
    Component.prototype.show.call(this);
    var $element = this.getElement();
    $element.find('.multiple-forward-window-bg').show();
};
MultipleForwardWindow.prototype.hide = function () {
    Component.prototype.hide.call(this);
    var $element = this.getElement();
    $element.find('.multiple-forward-window-submit').css('background','grey')
    $element.find('.multiple-forward-window-submit').css('border','1px solid grey')
    $element.find('.multiple-forward-window-bg').hide();
};

module.exports = MultipleForwardWindow;
